(() => {
  const init = (root) => {
    if (root.dataset.modelReady) return;
    root.dataset.modelReady = 'true';
    const catalog = JSON.parse(root.querySelector('[data-model-catalog]').textContent);
    const text = JSON.parse(root.querySelector('[data-model-text]').textContent);
    const grid = root.querySelector('[data-model-grid]');
    const controls = root.querySelector('[data-model-controls]');
    const carSelect = root.querySelector('[data-car]');
    const activeFilterCount = root.querySelector('[data-active-filter-count]');
    const stockSelect = root.querySelector('[data-availability]');
    const typeSelect = root.querySelector('[data-part-type]');
    const resultCount = root.querySelector('[data-result-count]');
    const empty = root.querySelector('[data-empty]');
    const clear = root.querySelector('[data-clear]');
    const more = root.querySelector('[data-show-more]');
    const loadStatus = root.querySelector('[data-load-status]');
    const loadMessage = root.querySelector('[data-load-message]');
    const retry = root.querySelector('[data-retry]');
    const pagination = root.querySelector('[data-pagination]');
    const fitment = root.querySelector('[data-fitment]');
    const seriesByModel = {wrx: ['wrx-gc', 'wrx-gd', 'wrx-gr-gv', 'wrx-va', 'wrx-vb'], brz: ['brz-zc6', 'brz-zd8'], levorg: ['levorg-vn5']};
    const knownModels = new Set(['all', 'wrx', 'brz', 'levorg', 'other']);
    const params = {model: 'subinats_model', series: 'subinats_series', stock: 'subinats_stock', type: 'subinats_type'};
    const chunk = 24;
    let limit = chunk;
    let next = root.dataset.next;
    const initialPage = root.dataset.page || '1';
    if (initialPage !== '1') {
      const firstPage = new URL(window.location.href);
      firstPage.searchParams.set('page', '1');
      next = firstPage.href;
    }
    let loading = false;
    let failed = false;
    let cards = [];
    let state = {model: 'all', series: 'all', stock: 'all', type: 'all'};

    const normalizeType = (value) => {
      const key = value.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
      const aliases = {bodykit: 'body-kits', bodykits: 'body-kits', bumper: 'bumpers', bumpers: 'bumpers', foglampcover: 'fog-lamp-covers', foglampcovers: 'fog-lamp-covers'};
      return aliases[key] || key || 'other';
    };
    const typeLabel = (value) => text.typeAliases[normalizeType(value)] || value || text.emptyType;
    const readCards = () => {
      cards = [...grid.querySelectorAll('[data-subinats-product]')].map(el => {
        const membership = catalog[el.dataset.subinatsProduct] || {models: ['other'], series: []};
        return {el, id: el.dataset.subinatsProduct, models: membership.models, series: membership.series, stock: el.dataset.stock, type: normalizeType(el.dataset.type), typeLabel: typeLabel(el.dataset.type)};
      });
    };
    const readState = () => {
      const search = new URL(window.location.href).searchParams;
      state = Object.fromEntries(Object.entries(params).map(([key, name]) => [key, search.get(name) || 'all']));
      if (!knownModels.has(state.model)) state.model = 'all';
      if (!(seriesByModel[state.model] || []).includes(state.series)) state.series = 'all';
      if (!['all', 'in-stock', 'pre-order'].includes(state.stock)) state.stock = 'all';
    };
    const writeState = () => {
      const url = new URL(window.location.href);
      url.searchParams.delete('page');
      for (const [key, name] of Object.entries(params)) {
        if (state[key] === 'all') url.searchParams.delete(name);
        else url.searchParams.set(name, state[key]);
      }
      if (url.href !== window.location.href) history.pushState({subinatsModels: true}, '', url);
    };
    const inModel = (card) => state.model === 'all' || card.models.includes(state.model);
    const inSeries = (card) => state.series === 'all' || card.series.includes(state.series);
    const renderCar = () => {
      const choice = state.series !== 'all' ? state.series : state.model;
      carSelect.value = [...carSelect.options].some(option => option.value === choice) ? choice : state.model;
    };
    const renderTypes = () => {
      const choices = new Map();
      for (const card of cards.filter(c => inModel(c) && inSeries(c))) choices.set(card.type, card.typeLabel);
      if (state.type !== 'all' && !choices.has(state.type) && (next || loading)) {
        const currentLabel = [...typeSelect.options].find(option => option.value === state.type)?.text;
        choices.set(state.type, currentLabel || state.type.replace(/-/g, ' '));
      }
      typeSelect.replaceChildren(new Option(text.allTypes, 'all'));
      for (const [key, label] of [...choices].sort((a, b) => a[1].localeCompare(b[1]))) typeSelect.add(new Option(label, key));
      if (!choices.has(state.type)) state.type = 'all';
      typeSelect.value = state.type;
    };
    const render = () => {
      renderTypes();
      stockSelect.value = state.stock;
      renderCar();
      const activeParts = Number(state.stock !== 'all') + Number(state.type !== 'all');
      activeFilterCount.hidden = activeParts === 0;
      activeFilterCount.textContent = String(activeParts);
      fitment.textContent = state.model === 'other' ? text.otherNote : state.model === 'levorg' ? text.levorgNote : text.fitment;
      const matching = cards.filter(card => inModel(card) && inSeries(card) && (state.stock === 'all' || card.stock === state.stock) && (state.type === 'all' || card.type === state.type));
      const shown = new Set(matching.slice(0, limit));
      for (const card of cards) card.el.hidden = !shown.has(card);
      resultCount.textContent = text.results.replace('__COUNT__', String(matching.length));
      empty.hidden = matching.length > 0 || loading || Boolean(next);
      more.hidden = matching.length <= limit;
      clear.hidden = Object.values(state).every(v => v === 'all');
      root.setAttribute('aria-busy', String(loading));
      loadStatus.hidden = !loading && !failed;
      loadMessage.textContent = failed ? text.loadError : text.loading;
      retry.hidden = !failed;
      pagination.hidden = !failed;
    };
    const loadRemaining = async () => {
      if (loading || !next) return;
      loading = true;
      failed = false;
      render();
      try {
        const seenPages = new Set([initialPage]);
        while (next && root.isConnected) {
          const url = new URL(next, window.location.origin);
          if (url.origin !== window.location.origin) throw new Error('Pagination is outside the collection');
          if (seenPages.has(url.searchParams.get('page'))) {
            if (cards.length === Number(root.dataset.total)) {next = ''; break;}
            throw new Error('Pagination did not advance');
          }
          seenPages.add(url.searchParams.get('page'));
          const current = new URL(window.location.href);
          url.searchParams.set('view', 'subinats-model-review');
          if (current.searchParams.has('preview_theme_id')) url.searchParams.set('preview_theme_id', current.searchParams.get('preview_theme_id'));
          for (const name of Object.values(params)) url.searchParams.delete(name);
          url.searchParams.set('section_id', root.dataset.sectionId);
          const response = await fetch(url, {credentials: 'same-origin'});
          if (!response.ok) throw new Error('Collection page could not load');
          const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = parsed.querySelector('[data-subinats-models]');
          if (!incoming) throw new Error('Collection page is unavailable');
          const known = new Set(cards.map(card => card.id));
          const additions = [];
          for (const card of incoming.querySelectorAll('[data-model-grid] > [data-subinats-product]')) {
            if (!known.has(card.dataset.subinatsProduct)) {
              known.add(card.dataset.subinatsProduct);
              additions.push(card);
            }
          }
          if (initialPage !== '1' && url.searchParams.get('page') === '1') grid.prepend(...additions);
          else grid.append(...additions);
          next = incoming.dataset.next;
          readCards();
          render();
        }
      } catch (error) {
        failed = true;
      } finally {
        loading = false;
        render();
      }
    };

    readCards();
    readState();
    render();
    controls.hidden = false;
    carSelect.addEventListener('change', () => {
      const choice = carSelect.value;
      if (knownModels.has(choice)) {
        state.model = choice;
        state.series = 'all';
      } else {
        state.model = Object.keys(seriesByModel).find(model => seriesByModel[model].includes(choice)) || 'all';
        state.series = state.model === 'all' ? 'all' : choice;
      }
      state.type = 'all';
      limit = chunk;
      render();
      writeState();
    });
    [stockSelect, typeSelect].forEach(select => select.addEventListener('change', () => {
      state.stock = stockSelect.value;
      state.type = typeSelect.value;
      limit = chunk;
      render();
      writeState();
    }));
    clear.addEventListener('click', () => {
      state = {model: 'all', series: 'all', stock: 'all', type: 'all'};
      limit = chunk;
      render();
      writeState();
    });
    more.addEventListener('click', () => {limit += chunk; render();});
    retry.addEventListener('click', loadRemaining);
    window.addEventListener('popstate', () => {
      if (!root.isConnected) return;
      readState();
      limit = chunk;
      render();
    });
    loadRemaining();
  };
  const initAll = () => document.querySelectorAll('[data-subinats-models]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once: true});
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

